import { SizeSIcon } from './SizeSIcon';

/**
 * author: Austin Andrews
 * id AE5079DB-D7D6-4F38-85C1-FAE6CDF14CC2
 * name size-s
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/size-s.svg
 * tags
 */
export const SizeSmallIcon = SizeSIcon;
export default SizeSmallIcon